export default __webpack_public_path__ + "static/meta-6ee6cf028d4f3a416a54f7d27968bea0.svg";